'use strict'

export default (mockAxios) => {
  // タグの選択肢を取得する
  mockAxios.onGet(new RegExp(`/(mgtags|personal-settings/tags)/seltags`)).reply((config) => {
    if (config.url.indexOf('mgtags') !== -1) {
      return [200, {
        'success': true,
        'data': [
          {
            'id': 1,
            'name': '共有サンプルタグ 1',
            'color': '000000lo',
            'color_rgb': '#ffecb3',
            'openflag': '1'
          },
          {
            'id': 2,
            'name': '共有サンプルタグ 2',
            'color': '000000lr',
            'color_rgb': '#f8bbd0',
            'openflag': '1'
          },
          {
            'id': 3,
            'name': '共有サンプルタグ 3',
            'color': '000000lb',
            'color_rgb': '#b3e5fc',
            'openflag': '1'
          }
        ],
        'pagination': {
          'page_count': 1,
          'current_page': 1,
          'has_next_page': false,
          'has_prev_page': false,
          'count': 3,
          'limit': 10
        }
      }]
    }

    return [200, {
      'success': true,
      'data': [
        {
          'id': 11,
          'name': '個人サンプルタグ 1',
          'color': '000000do',
          'color_rgb': '#ffc107',
          'openflag': '0'
        },
        {
          'id': 12,
          'name': '個人サンプルタグ 2',
          'color': '000000dg',
          'color_rgb': '#4caf50',
          'openflag': '0'
        },
        {
          'id': 13,
          'name': '個人サンプルタグ 3',
          'color': '000000db',
          'color_rgb': '#03a9f4',
          'openflag': '0'
        }
      ],
      'pagination': {
        'page_count': 1,
        'current_page': 1,
        'has_next_page': false,
        'has_prev_page': false,
        'count': 3,
        'limit': 10
      }
    }]
  })

  // タグカラー一覧を取得
  mockAxios.onGet(`/personal-settings/tags/colors`).reply(200, {
    'success': true,
    'tag_colors': [
      {
        'id': '000000dr',
        'rgb': '#e91e63'
      },
      {
        'id': '000000do',
        'rgb': '#ffc107'
      },
      {
        'id': '000000dg',
        'rgb': '#4caf50'
      },
      {
        'id': '000000db',
        'rgb': '#03a9f4'
      },
      {
        'id': '000000dp',
        'rgb': '#673ab7'
      },
      {
        'id': '000000dh',
        'rgb': '#9e9e9e'
      },
      {
        'id': '000000lr',
        'rgb': '#f8bbd0'
      },
      {
        'id': '000000lo',
        'rgb': '#ffecb3'
      },
      {
        'id': '000000lg',
        'rgb': '#c8e6c9'
      },
      {
        'id': '000000lb',
        'rgb': '#b3e5fc'
      },
      {
        'id': '000000lp',
        'rgb': '#d1c4e9'
      },
      {
        'id': '000000lh',
        'rgb': '#e0e0e0'
      }
    ]
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/tagRepositoryMock.js